module.exports = __webpack_public_path__ + "static/media/GGStates7.f40154ff.svg";